import { HEADER_CLIENT_RELEASE } from "@faire/web/common/consts/HEADER_CLIENT_RELEASE";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

import { headerInterceptorFactory } from "./headerInterceptor";

export const releaseVersionHeaderInterceptor = headerInterceptorFactory({
  header: HEADER_CLIENT_RELEASE,
  value: () => getGlobalProperty("releaseVersion"),
});
